export const MESSAGES_LIST_RESET = 'MESSAGES_LIST_RESET';

export const MESSAGES_LIST_GET_START = 'MESSAGES_LIST_GET_START';
export const MESSAGES_LIST_GET_SUCCESS = 'MESSAGES_LIST_GET_SUCCESS';
export const MESSAGES_LIST_GET_FAILURE = 'MESSAGES_LIST_GET_FAILURE';
